module.exports = __webpack_public_path__ + "img/Seguro_de_auto_header.4db8c624.jpeg";